import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';
import { Balikovna } from 'shared-ui/providers/balikovna';
import { BalikovnaPickupComponent } from 'shared-ui/providers/balikovna-pickup.component';

@Injectable({ providedIn: 'root' })
export class BalikovnaPickup {
  private dialog = inject(MatDialog);
  point = new Subject<null | Balikovna['Point']>();

  constructor() {
    window.addEventListener('message', event => {
      if (event.data.point && event.data.message === 'pickerResult') {
        this.point.next(event.data.point);
      }
    });
  }

  pick(): Observable<null | Balikovna['Point']> {
    const dialog = this.dialog.open(BalikovnaPickupComponent, {
      maxWidth: '100vw',
      width: 'calc(100vw - 32px)',
      height: 'calc(100vh - 32px)',
    });
    return dialog.afterClosed();
  }
}
